import React from 'react';
import { connect } from 'react-redux';
import { REDUCER_NAME } from '../reducer';
import { getItemMinInList } from '../../../../helpers/Common';
import Const from './../Const';
import { I18n } from 'react-redux-i18n';

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    listYearTable: state[REDUCER_NAME].listYearTable,
  };
};

export default connect(mapStateToProps)(TimeRange);

function TimeRange(props) {
  const { listYearTable } = props;

  const timeRange_ = `${I18n.t('marketInDepthAnomaly.timeRange')} `;
  const from_ = `${I18n.t('marketInDepthAnomaly.from')} `;
  const to_ = `${I18n.t('marketInDepthAnomaly.to')} `;
  const present = I18n.t('marketInDepthAnomaly.present');

  return (
    <div className="time-range-text float-right">
      <div className="text-right mt-10 d-flex" style={{ whiteSpace: 'nowrap' }}>
        <span style={{ fontWeight: '600', marginRight: '5px' }}>
          {timeRange_}
        </span>
        <span style={{ opacity: '0.5', marginRight: '5px' }}>{from_}</span>
        <span style={{ fontWeight: '600', marginRight: '5px' }}>
          {getItemMinInList(listYearTable, [Const.average])}{' '}
        </span>
        <span style={{ opacity: '0.5', marginRight: '5px' }}>{to_}</span>
        <span style={{ fontWeight: '600' }}>{present}</span>
      </div>
    </div>
  );
}
